<template>
  <div :class="[$style.example_content_item]">
    <div :class="$style.example_content_item_title">
      {{ title }}
    </div>
    <div :class="$style.example_content_2_items">
      <div
        :class="$style.example_block"
        @click="()=>onCreateReport('project', budgetTitleLocales.budgetByProjects)"
      >
        <div :class="$style.example_block_title">
          <div :class="$style.text">
            {{ locale(`${budgetTitleLocales.budgetByProjects}`) }}
          </div>

          <vgp-button
            type="text"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`exmp_chart_budget_project_desc`) }}
        </div>
        <div :class="$style.example_block_chart">
          <img
            :class="$style.img"
            :src="'https://cdn.ganttpro.com/app/imgs/reports/reportBudgetProjects.png'"
          >
        </div>
      </div>
      <div
        :class="$style.example_block"
        @click="()=>onCreateReport('month', budgetTitleLocales.budgetByMonth)"
      >
        <div :class="$style.example_block_title">
          <div :class="$style.text">
            {{ locale(`${budgetTitleLocales.budgetByMonth}`) }}
          </div>

          <vgp-button
            type="text"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`exmp_chart_budget_resource_desc`) }}
        </div>
        <div :class="$style.example_block_chart">
          <img
            :class="$style.img"
            :src="'https://cdn.ganttpro.com/app/imgs/reports/reportBudgetMonth.png'"
          >
        </div>
      </div>
    </div>
    <div :class="$style.example_content_2_items">
      <div
        :class="[$style.example_block, $style.full_size]"
        @click="()=>onCreateReport('resource', budgetTitleLocales.budgetByResource)"
      >
        <div :class="$style.example_block_title">
          <div :class="$style.text">
            {{ locale(`${budgetTitleLocales.budgetByResource}`) }}
          </div>

          <vgp-button
            type="text"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`${budgetTitleLocales.budgetByResource}_desc`) }}
        </div>
        <div :class="$style.example_block_chart">
          <img
            :class="$style.img"
            :src="'https://cdn.ganttpro.com/app/imgs/reports/reportBudgetByResource.png'"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import vgpSvgImage from '$$vueCmp/VueIcon/vgpSvgImage.vue';
import reportConstants from '../constants';

export default {
  components: {
    vgpSvgImage,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: [
    'onCreateReport',
  ],
  data() {
    return {
      locale: __,
      budgetTitleLocales: reportConstants.TITLE.budget,
    };
  },
  methods: {
    onCreateReport(type, title) {
      this.$emit('onCreateReport', {
        title,
        type,
        routerName: 'budgetReports',
      });
    },
  },
};
</script>

<style module src='./../../less/reportsMain.less'></style>
